var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1750",
    "data-name": "Group 1750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.39,
    height: 12.688,
    viewBox: "0 0 10.39 12.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 10.39,
    height: 12.688,
    fill: "#2e343d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M19.983,67.946c0,1,0,2,0,3a2.242,2.242,0,0,1-2.34,2.354q-2.286,0-4.572,0a2.237,2.237,0,0,1-2.315-2.323q0-3.1,0-6.192a1.1,1.1,0,0,1,.041-.346.573.573,0,0,1,1.106.191c.012.315,0,.631,0,.946q0,2.677,0,5.354a1.115,1.115,0,0,0,1.229,1.219q2.245,0,4.491,0a1.11,1.11,0,0,0,1.2-1.216q0-3,0-6c0-.072,0-.144,0-.216a.577.577,0,0,1,.584-.635.564.564,0,0,1,.566.621c.006.568,0,1.136,0,1.7q0,.771,0,1.541",
    transform: "translate(-10.172 -60.616)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M2.884,1.711c0-.34,0-.67,0-1,0-.5.205-.709.7-.71Q5.195,0,6.8,0c.5,0,.7.205.705.707,0,.331,0,.661,0,1.023H8.967c.261,0,.523,0,.784,0a.579.579,0,1,1-.012,1.149q-2.879,0-5.758,0c-1.117,0-2.235,0-3.352,0a.577.577,0,1,1,.01-1.148c.676,0,1.352,0,2.027,0,.061,0,.123-.01.217-.019m1.177,0H6.327v-.54H4.061Z",
    transform: "translate(0 0)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M65.24,87.964c0,.639,0,1.278,0,1.917,0,.409-.232.669-.58.665s-.57-.265-.57-.677q0-1.917,0-3.835c0-.412.223-.674.569-.678s.58.259.582.691c0,.639,0,1.278,0,1.917",
    transform: "translate(-60.623 -80.742)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M106.856,87.956c0-.648,0-1.3,0-1.944a.58.58,0,0,1,.566-.651.587.587,0,0,1,.583.663q0,1.931,0,3.862a.588.588,0,0,1-.582.665c-.349,0-.566-.259-.568-.677,0-.639,0-1.278,0-1.917",
    transform: "translate(-101.079 -80.747)",
    fill: "#2e343d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.99541e4db2a0b228583433b314ae7483.svg";
export { ForwardRef as ReactComponent };